// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"d09524ac","492":"d09524ac","517":"cdfda08b","745":"d09524ac"}[chunkId] + ".chunk.css";
};